<template>

    <div>

        <modal :showModal="showModal" :hideModal="closeModal">

            <h5 slot="header">Vue du PV {{fineCode}}</h5>

            <div slot="body" class="w-100">

                <div v-html="fineHtml"></div>

            </div>

            <div slot="footer">
                <button class="btn btn-danger" @click="closeModal">Fermer</button>
            </div>

        </modal>

    </div>

</template>

<script>

    import Modal from './Modal';
    import axios from "axios";

    export default {
        name: 'fineHtmlModal',
        props: {
            showModal: Boolean,
            closeModal: Function,
            fineCode: {
                type: String,
                required: true
            }
        },
        components: {Modal},
        data() {
            return {
                fineHtml: null
            }
        },
        created() {
            this.getHtmlFine(this.fineCode)
        },
        methods: {
            async getHtmlFine(fineCode) {
                await axios.get('/api/fines/html/' + fineCode)
                    .then(result => {
                        this.fineHtml = result.data;
                    });
            }
        }
    }

</script>


// WEBPACK FOOTER //
// resources/js/components/layout/FineHtmlModal.vue